import React, { useContext } from 'react';
import './Links.scss';
import { FaInstagram } from 'react-icons/fa';
import { LiaLinkedin } from 'react-icons/lia';
import MyContext from '../../Context/MyContext';

const Links = () => {

  const{handleOpenModal} =useContext(MyContext)
  const dashboardLinks = [
   
    { id: 1, title: 'Instagram', url: 'https://www.instagram.com/v_extech/?igshid=Zjc2ZTc4Nzk%3D','icon':<FaInstagram/> },
    { id: 2, title: 'LinkedIn', url: 'https://www.linkedin.com/company/82998848/admin/dashboard/', 'icon':<LiaLinkedin/> },
  ];

  return (
    <div className="links-container">
      <div className="header">
      
        <p>Follow us for the latest updates on holidays, important announcements, tips, and resources designed especially for students. Don’t miss out!</p>
      </div>
      <ul className="links-list">
        {dashboardLinks.map((link) => (
          <li key={link.id} className="links-item">
            <a href={link.url} className="link" target="_blank" rel="noopener noreferrer">
             {link.icon} {link.title}
            </a>
          </li>
        ))}
      </ul>

      <div className="attendance" onClick={handleOpenModal} >
     
      Fill Today's Attendance
    
      </div>
    
    </div>
  );
};

export default Links;
